"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function vrc(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M15.1987 5.25H18.75L12 18.75L5.25 5.25H8.778L12.0233 12.0848L15.1987 5.25ZM12 8.96925C11.409 8.96925 10.9297 8.47725 10.9297 7.8705C10.9297 7.26375 11.409 6.771 12 6.771C12.591 6.771 13.0703 7.26375 13.0703 7.8705C13.0703 8.47725 12.5903 8.96925 12 8.96925ZM16.8488 11.9993C17.4397 11.9993 17.919 12.492 17.9183 13.0988C17.9183 13.7063 17.4397 14.1975 16.8488 14.1975C16.2578 14.1975 15.7785 13.7055 15.7785 13.0988C15.7785 12.492 16.2578 12 16.8488 12V11.9993Z", fill: color }));
}
exports["default"] = vrc;
//# sourceMappingURL=vrc.js.map